import { Badge } from '@ui';
import { BadgeProps } from '@ui/Badge';
import { useTranslation } from 'react-i18next';
import { AllocationStatus } from './types';

interface Props {
    status: AllocationStatus;
    size?: BadgeProps['size'];
}

// Shared badge colour per status — kept in one map so the badge stays readable.
const STATUS_COLORS: Record<AllocationStatus, BadgeProps['color']> = {
    active: 'success',
    inactive: 'light',
    cancelled: 'light',
    pending: 'warning',
    awaiting_payment: 'warning',
    rejected: 'error',
    expired: 'error'
};

const AllocationStatusBadge = ({ status, size = 'xs' }: Props) => {
    const { t } = useTranslation('space-manager');

    if (!status) return <>-</>;

    return (
        <Badge flat color={STATUS_COLORS[status] ?? 'light'} size={size} className="tw-whitespace-nowrap">
            {t(`allocationStatus.${status}`, { defaultValue: status })}
        </Badge>
    );
};

export default AllocationStatusBadge;
